import React from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import '../styles/error404.css'
import logo from '../img/n89.png'

const Error404 = () => {
  const navigate = useNavigate()

  return (
    <section className="error404">
      <Helmet>
        <title>Page not found</title>
        <meta name="theme-color" content="#000000" />
      </Helmet>
      <img alt="Pinweelo" src={logo} />
      <div>
        <h1>This page doesn’t exist</h1>
        <h2>Error 404</h2>
        <button type="button" onClick={() => navigate('/')}>Go home</button>
      </div>
    </section>
  )
}

export default Error404
